import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ReactGA, { event } from 'react-ga';
import ReactTooltip from 'react-tooltip';
import { debounce as _debounce } from 'lodash';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';

import ConversationList from './List/index';
import Search from './Search';
import DetailsPane from '../../containers/ConversationDetailsContainer';
import Loading from '../common/Loading';
import Report from './Reporting';
import Block from './BlockNumber';
import OptOutNumber from './OptOutNumber';
import LocationSelector from './LocationSelector';
import ConversationDetails from './ConversationDetails';
import FilterConversation from '../DropdownMenu/FilterConversation';
import BusinessName from '../Dashboard/BusinessName/businessName';
import StatusSelectDropdown from '../DropdownMenu/ReportSelection';
import BlockOverlay from './ConversationDetails/BlockOverlay';
import OptoutOverlay from './ConversationDetails/OptoutOverlay';

import utils from '../../lib/utils';
import helpers from './helpers';
import conversationcreate from '../../assets/images/conversationcreate.svg';
import filter_icon from '../../assets/images/filter_icon.svg';
import filter_icon_blue from '../../assets/images/filter_icon_blue.svg';
import location_pin from '../../assets/images/location_pin.png';
import BookDemo from '../../assets/images/book_demo.svg';
import BookDemoDowmn from '../../assets/images/book_demo_down.svg';

import './index.scss';
import classNames from 'classnames';
import CreateTagOverlay from './ConversationDetails/CreateTagOverlay';
import { csroles } from '../../assets/CSroles';

const ltrim = (str) => {
  if (!str) return str;
  return str.replace(/^\s+/g, '');
};

const generateTemplate = (text, highlight) => {
  if (highlight) {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    const parsedString = (
      <span>
        {parts.map((part) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span className="highlight-text">{part}</span>
          ) : (
            part
          ),
        )}
      </span>
    );
    return parsedString;
  } else {
    return <span>{text}</span>;
  }
};

const getPhoneNumber = (contact) => {
  const phone_number = contact.contacts.filter(
    (phone) => phone.type === 'PHONE',
  );
  return phone_number.length > 0 ? phone_number[0].value : '';
};

const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const getToolTipPosition = () => {
  if (window.innerWidth < 768) {
    return 'right';
  } else {
    return 'top';
  }
}

const THIRTY_DAYS_IN_MS = 31 * 24 * 60 * 60 * 1000;

class Conversations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paneVisibility: false,
      handled: 0,
      unhandled: 0,
      selectedConversation: null,
      selectedDetailsConversation: null,
      searchText: null,
      searchLocal: null,
      mainpage: true,
      conversationslist: [],
      allConversationCount: 0,
      follupConversationCount: 0,
      myconversationCount: 0,
      showSearch: false,
      activeCategory: 'MINE',
      showFilter: false,
      assignedUser: null,
      filter: [],
      appliedFilter: [],
      createNewConversation: false,
      selectedLocation: {},
      addOnNotEnabled: true,
      version: 2.0,
      myList: [],
      unassignedList: [],
      defaultviewset: false,
      transitioned: [],
      dontShowTransition: false,
      filteredSearchList: [],
      searchLoading: false,
      showLocationSelection: false,
      searchContact: {},
      showMobileDetailsView: false,
      newCreateSelected: true,
      playNotification: false,
      isUserIdSearch: false,
      statusDropdownVisibility: false,
      blockOverlay: false,
      optoutOverlay: false,
      tagOverlay: false,
      lastNotifiedMessageId: null,
    };
    this.conversationslist = [];
    this.searchList = [];
    this.debouncedConversationSelect = _debounce(this.handleConversationSelect, 300);
  }
  componentDidMount = () => {
    if (this.props.business && this.props.business.details.id) {
      // Fetch business details
      const { auth } = this.props;
      const { userid, studio_id, features } = auth;
      const bzid = this.props.business.id || studio_id;
      this.props.getBusinessDetails(bzid);
      this.props.getConversations(bzid, false);
      this.props.getConvMetric(bzid);
      this.props.getAssignedConversation();
      this.props.getCustomTags();
      //socket connection
      this.props.scoketHandshake(userid, studio_id);
      ReactGA.set({ dimension5: studio_id });
      const { locations } = this.props.business;
      if (features && features.length > 0) {
        this.setState({
          addOnNotEnabled: !features.includes('BUSINESS_MESSENGER_ENABLED'),
        });
      }
      if (locations && locations.length > 0) {
        const brand_location = locations.filter((location) =>
          location.brand_ids.includes(location.studioId),
        );
        const selectedLocation =
          brand_location.length > 0 ? brand_location[0] : locations[0];
        this.setState({
          selectedLocation,
        });
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params["userId"]) {
      const userId = params["userId"].replace(' ', '+');
      sessionStorage.setItem('searchText', userId);
      sessionStorage.setItem('search', true);

      this.setState({
        searchLocal: userId,
        searchText: userId,
        isUserIdSearch: true,
      }, () => {
        this.onApplyfilter();
        this.searchConversationFunc({ target: { value: userId } });
      });

      // If recId is present, open a new window with the constructed URL
      if (params["recId"]) {
        const recordingUrl = `${window.Config.API_URL}/business/recording/${userId}/${params["recId"]}`;
        window.open(recordingUrl, '_blank');
      }
    }
    // app/conversation?userId=504318-%2B1408695026&recId=RE5697de8af232af22e2400958884cb638.mp3
    // business/recording/504318-%2B1408695026/RE5697de8af232af22e2400958884cb638.mp3

    ReactGA.event({
      category: 'User',
      action: 'click on conversation',
      label: 'Conversation Data',
    });
    ReactGA.pageview(window.location.hash);
    setTimeout(() => {
      this.setState({
        playNotification: true
      })
    }, 7000)
  };
  componentWillUnmount() {
    this.props.disconnectScoket();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.business.isInfoFetched &&
      nextProps.business.isInfoFetched !== this.props.business.isInfoFetched
    ) {
      const { auth } = this.props;
      const { userid, studio_id, features } = auth;
      const bzid = nextProps.business.id || studio_id;
      this.props.getBusinessDetails(nextProps.business.id);
      this.props.getConversations(bzid, false);
      this.props.getConvMetric(bzid);
      this.props.scoketHandshake(userid, studio_id);
      this.props.getAssignedConversation();
      this.props.getCustomTags();
      ReactGA.set({ dimension5: this.props.business.id });
      if (features && features.length > 0) {
        this.setState({
          addOnNotEnabled: !features.includes('BUSINESS_MESSENGER_ENABLED'),
        });
      }
    }

    if (
      nextProps.business &&
      !utils.isEmptyObject(nextProps.business.conversation_locations) &&
      utils.isEmptyObject(this.state.selectedLocation)
    ) {
      const brand_location = nextProps.business.conversation_locations.filter(
        (location) => location.brand_ids.includes(location.studioId),
      );
      const selected_loc = brand_location.length > 0 ? brand_location[0] : nextProps.business.conversation_locations[0];
      this.setState({
        selectedLocation: selected_loc,
      });
      this.props.changeStoreLocation(selected_loc);
    }
    if (
      nextProps.conversations.getconversations !== true &&
      nextProps.conversations.getconversations !==
      this.props.conversations.getconversations
    ) {
      this.calculateSummary(nextProps);
    }
    if (nextProps.conversations.searchingConversation !== this.props.conversations.searchingConversation) {
      this.calculateSummary(nextProps);
    }
    if (
      nextProps.conversations &&
      nextProps.conversations.statusupdate &&
      nextProps.conversations.statusupdate.getTime() >
      nextProps.conversations.lastupdate.getTime()
    ) {
      // if(nextProps.conversations.markedAsResolved){
      // setTimeout(()=>{this.calculateSummary(nextProps)},2000);
      // setTimeout(()=>{this.props.markResolveClear()},5000);
      // }else{
      this.calculateSummary(nextProps);
      //}
    }
    if (
      nextProps.conversations &&
      nextProps.conversations.socketUpdate &&
      nextProps.conversations.socketUpdate.getTime() >
      this.props.conversations.socketUpdate.getTime()
    ) {
      this.calculateSummary(nextProps);
    }
    if (
      this.props.location.pathname === nextProps.location.pathname &&
      !sessionStorage.getItem('search') &&
      this.props.conversations.search
    ) {
      this.backfromSearch();
    }
    if (
      nextProps.conversations.getconversations !== true &&
      nextProps.conversations.conversations.length > 0
    ) {
      // if(nextProps.conversations.markedAsResolved){
      // setTimeout(()=>{this.calculateSummary(nextProps)},2000);
      // setTimeout(()=>{this.props.markResolveClear()},5000);
      // }else{
      this.calculateSummary(nextProps);
      //}
    }
    if (
      nextProps.business.isLocationfetchsuccess &&
      nextProps.business.isLocationfetchsuccess !==
      this.props.business.isLocationfetchsuccess
    ) {
      const { business } = nextProps;
      const { locations } = business;
      const { selectedLocation } = this.state;
      if (
        business &&
        !utils.isEmptyObject(locations) &&
        utils.isEmptyObject(selectedLocation)
      ) {
        const brand_location = locations.filter((location) =>
          location.brand_ids.includes(location.studioId),
        );
        if (brand_location.length > 0) {
          this.onLocationChange(brand_location[0]);
        }
      }
    }
    if (
      this.state.paneVisibility === true &&
      nextProps.conversations.sessioncounter !==
      this.props.conversations.sessioncounter
    ) {
      const selectedConv = nextProps.conversations.conversations.filter(
        (conversation) =>
          conversation.id === this.state.selectedConversation.id,
      );
      if (selectedConv && selectedConv.length > 0) {
        this.setState({
          selectedConversation: selectedConv[selectedConv.length - 1],
        });
      }
    }
    if (
      nextProps.conversations.ongoingSearch === false &&
      nextProps.conversations.ongoingSearch !=
      this.props.conversations.ongoingSearch
    ) {
      this.setState({
        filteredSearchList: nextProps.conversations.contactSearch,
        searchLoading: false,
      });
    } else if (nextProps.conversations.ongoingSearch === true) {
      this.setState({
        filteredSearchList: nextProps.conversations.contactSearch,
        searchLoading: true,
      });
    }
    if (nextProps.conversations.creatingNewConversation !== this.props.conversations.creatingNewConversation) {
      if (nextProps.conversations.creatingNewConversation === false) {
        this.setState({
          createNewConversation: false
        })
      }
    }
    if (nextProps.conversations.callerNameChange !== this.props.conversations.callerNameChange && nextProps.conversations.callerNameChange === false) {
      this.setState({
        selectedDetailsConversation: this.state.selectedConversation
      })
    }

  }
  onLocationChange = (location) => {
    this.setState({
      selectedLocation: location,
      dontShowTransition: true,
      showLocationSelection: false,
    });
    this.props.changeStoreLocation(location);
    this.props.getBusinessDetails(location.studioId);
    this.props.getConversations(location.studioId, false);
    this.props.getConvMetric(location.studioId);
    this.props.getBlockUser(location.studioId);
  };
  locationChangeAndCreateConversation = (location) => {
    if (location.is_brand) {
      this.setState(
        {
          selectedLocation: location,
          dontShowTransition: true,
          showLocationSelection: false,
        },
        () => this.addNewBrandConversation(),
      );

    } else {
      this.setState(
        {
          selectedLocation: location,
          dontShowTransition: true,
          showLocationSelection: false,
        },
        () => this.addNewConversation(),
      );
      this.props.changeStoreLocation(location);
      this.props.getBusinessDetails(location.studioId);
      this.props.getConversations(location.studioId, false);
      this.props.getConvMetric(location.studioId);
      this.props.getBlockUser(location.studioId);
    }
  };
  calculateSearchSummary(conversations) {
    this.searchList = [];
    let group = this.groupBykey(conversations, 'userId');
    group = group.map((data) => {
      return this.groupBykeyandreOrder(data.conversations);
    });
    return this.searchList;
  }
  mergeArrays = (arr1, arr2) => {
    const merged = [...arr1, ...arr2].reduce((acc, obj) => {
      acc.set(obj.id, obj); // This ensures that later objects (from arr2) override previous ones (from arr1)
      return acc;
    }, new Map());

    return Array.from(merged.values());
  }
  calculateSummary(nextProps) {
    const {
      searchLocal,
      appliedFilter,
      myList,
      unassignedList,
      addOnNotEnabled,
    } = this.state;
    const { auth } = this.props;
    const { allAssignmentMap, incomingMessage, custom_tags } = nextProps.conversations;
    const dashboard_settings = utils.getCookie('dashboard_settings');
    const assignedConversation = allAssignmentMap
      .filter((user) => user.assigned_to === auth.userid)
      .map((item) => item['assigned_user']);

    const allAssignedConversation = allAssignmentMap.map(
      (item) => item['assigned_user'],
    );
    this.conversationslist = [];
    let combinedSearchResults = [];
    if (this.state.searchLocal?.length > 0) {
      combinedSearchResults = [
        ...new Map(
          [...nextProps.conversations.conversations, ...nextProps.conversations.searchResults]
            .map(obj => [obj.id, obj]) // Use `id` as the unique key
        ).values()
      ];
    } else {
      combinedSearchResults = nextProps.conversations.conversations;
    }

    let group = this.groupBykey(
      combinedSearchResults,
      'userId',
    );
    group = group.map((data) => {
      return this.groupBykeyandreOrder(data.conversations);
    });
    let conversations = [...this.conversationslist];
    conversations.sort((a, b) => {
      if (a.endTime !== b.endTime && a.endTime !== 0 && b.endTime !== 0) {
        a.displayTime = a.endTime;
        b.displayTime = b.endTime;
        return a.endTime > b.endTime ? -1 : 1;
      } else {
        a.displayTime = a.startTime;
        b.displayTime = b.startTime;
        return a.startTime > b.startTime ? -1 : 1;
      }
    });
    const now = Date.now();
    conversations.sort((a, b) => {
      return a.endTime > b.endTime ? -1 : 1;
    });
    const recentConversations = conversations
      .filter(convo => now - convo.endTime <= THIRTY_DAYS_IN_MS)
      .sort((a, b) => b.endTime - a.endTime); // More concise sort
    let filterd_conversation = recentConversations;

    //Side Nav Count Live update --start--
    const unassigned_count = !addOnNotEnabled
      ? filterd_conversation.filter(
        (conversation) =>
          conversation.action == 'FOLLOWUP_NEEDED' &&
          !allAssignedConversation.includes(conversation.userId),
      )
      : filterd_conversation.filter(
        (conversation) => conversation.action == 'FOLLOWUP_NEEDED',
      );
    const my_count = filterd_conversation.filter(
      (conversation) =>
        (conversation.action == 'FOLLOWUP_NEEDED' ||
          conversation.auto_chat_status === 'PAUSED') &&
        assignedConversation.includes(conversation.userId),
    );
    const attentioncount = !addOnNotEnabled
      ? unassigned_count.length + my_count.length
      : unassigned_count.length;
    if (
      attentioncount &&
      this.props.conversations.sidenav_count !== attentioncount
    ) {
      this.props.attentionCount(attentioncount);
    }
    //Side Nav Count Live update --end--

    //Search and filter handling --start--
    if (searchLocal && searchLocal.length > 0) {
      const { auth } = this.props;
      const typeofUser =
        auth.domain_keywords && auth.domain_keywords.USER
          ? auth.domain_keywords.USER.toLowerCase()
          : 'client';
      filterd_conversation = conversations.filter((conversation) => {
        const name = helpers.getclientNameListMeta(conversation, typeofUser);
        const phone = helpers.getClientPhoneCleaned(conversation);
        if (!nextProps.conversations.searchingConversation) {
          if (
            name.toLowerCase().indexOf(searchLocal.toLowerCase()) !== -1 ||
            (helpers.getCleanedPhone(searchLocal).length > 0 &&
              phone.includes(helpers.getCleanedPhone(searchLocal))) ||
            conversation.userId === searchLocal
          ) {
            return conversation;
          }
        }
      });
    }
    const searched_filter = [...filterd_conversation];
    if (appliedFilter && appliedFilter.length > 0) {
      if (appliedFilter.includes('FOLLOWUP_NEEDED')) {
        filterd_conversation = filterd_conversation.filter(
          (conversation) => conversation.action === 'FOLLOWUP_NEEDED',
        );
      }
      if (appliedFilter.includes('PAUSED')) {
        filterd_conversation = filterd_conversation.filter(
          (conversation) => conversation.auto_chat_status === 'PAUSED',
        );
      }
      if (
        appliedFilter.includes('ME') ||
        appliedFilter.includes('OTHERS') ||
        appliedFilter.includes('NONE')
      ) {
        let assignmentFilter = [];
        if (appliedFilter.includes('ME')) {
          assignmentFilter = assignmentFilter.concat(assignedConversation);
        }

        if (appliedFilter.includes('OTHERS')) {
          const otherAssignments = allAssignedConversation.filter(function (el) {
            return !assignedConversation.includes(el);
          });
          assignmentFilter = assignmentFilter.concat(otherAssignments);
        }

        filterd_conversation = filterd_conversation.filter((conversation) =>
          assignmentFilter.includes(conversation.userId),
        );
        if (appliedFilter.includes('NONE')) {
          filterd_conversation = filterd_conversation.concat(
            searched_filter.filter(
              (conversation) =>
                !allAssignedConversation.includes(conversation.userId),
            ),
          );
        }
      }
      const tags = [
        'BOOKING',
        'NEW_BOOKING',
        'RESCHEDULE',
        'CANCELLATION',
        'BOOKING_REQUEST',
        'RESCHEDULE_REQUEST',
        'CANCEL_REQUEST',
        'NEW',
        'HAPPY',
        'UNHAPPY',
        'LE_CAMPAIGN_IN_PROGRESS',
        'LE_BOOKED_ON_TRUELARK',
        'LE_BOOKED_OFF_PLATFORM',
        'LE_ENGAGED',
        'LE_UNRESPONSIVE',
        'UNRESPONSIVE',
        'IS_LANDLINE',
        'LE_OPTED_OUT',
        'LE_EXPIRED_CAMPAIGN',
        'APPOINTMENT_REMINDER_IN_PROGRESS',
        'APPOINTMENT_REMINDER_CONFIRMED',
        'APPOINTMENT_REMINDER_CANCELLED',
        'APPOINTMENT_REMINDER_RESCHEDULED',
        'APPOINTMENT_REMINDER_OPTED_OUT',
        'APPOINTMENT_REMINDER_UNCONFIRMED',
        'APPOINTMENT_REMINDER_UNABLE_TO_SEND',
        'APPOINTMENT_REMINDER_RESCHEDULE_REQUESTED',
        'APPOINTMENT_REMINDER_CANCEL_REQUESTED',
        'USING_INSURANCE',
        'OUT_OF_POCKET',
      ];
      const customtags = custom_tags.map(tag => tag.name);
      const status = ['FOLLOWUP_NEEDED', 'PAUSED'];
      const assignedto = ['ME', 'OTHERS', 'NONE'];
      console.log('customtags1', customtags, tags.concat(status).concat(assignedto).concat(customtags));
      if (
        appliedFilter.some(
          (item) =>
            !tags
              .concat(status)
              .concat(assignedto)
              .concat(customtags)
              .includes(item),
        )
      ) {
        //filterd_conversation = filterd_conversation.filter(conversation=>appliedFilter.includes(conversation.initiatedFor));
        if (
          !appliedFilter.includes('MISSED_CALL') &&
          appliedFilter.includes('MISSED_CALL_VM')
        ) {
          filterd_conversation = filterd_conversation.filter(
            (conversation) =>
              conversation.initiatedFor === 'MISSED_CALL' &&
              conversation.tags &&
              conversation.tags.includes('HAS_VOICE_MAIL'),
          );
        } else {
          filterd_conversation = filterd_conversation.filter((conversation) => {
            if (appliedFilter.includes('MISSED_CALL')) {
              return appliedFilter.includes(conversation.initiatedFor) || conversation.initiatedFor === 'VOICE_CALL';
            }
            return appliedFilter.includes(conversation.initiatedFor);
          }
          );
        }
      }
      if (appliedFilter.some(item => tags.includes(item) || customtags.includes(item))) {
        const filtering = appliedFilter.includes('BOOKING')
          ? [...appliedFilter, 'NEW_BOOKING']
          : [...appliedFilter];
        filterd_conversation = filterd_conversation.filter((conversation) =>
          helpers
            .getTagsForFilter(conversation, true)
            .some((item) => filtering.includes(item)),
        );
      }
    }

    //Search and filter handling --end--

    const follupConversation = !addOnNotEnabled
      ? filterd_conversation.filter(
        (conversation) =>
          conversation.action == 'FOLLOWUP_NEEDED' &&
          !allAssignedConversation.includes(conversation.userId),
      )
      : filterd_conversation.filter(
        (conversation) => conversation.action == 'FOLLOWUP_NEEDED',
      );
    let assignedConversation_list = filterd_conversation.filter(
      (conversation) => assignedConversation.includes(conversation.userId)
    );

    let newlyCreatedAndAssigned = assignedConversation_list.filter(conv => conv.staffCreated);

    // Sort the array such that the elements with staffCreated = true come first
    assignedConversation_list.sort((a, b) => {
      if (a.staffCreated && !b.staffCreated) {
        return -1; // a should come before b
      } else if (!a.staffCreated && b.staffCreated) {
        return 1; // b should come before a
      } else {
        return 0; // no change in ordering
      }
    });

    //const dashboard_settings = utils.getCookie('dashboard_settings');
    if (
      incomingMessage &&
      (assignedConversation_list.filter(
        (conversation) => conversation.id === incomingMessage,
      )?.length > 0 ||
        follupConversation.filter(
          (conversation) => conversation.id === incomingMessage,
        )?.length > 0) &&
      dashboard_settings === 'true' &&
      this.state.playNotification &&
      this.state.lastNotifiedMessageId !== incomingMessage
    ) {
      helpers.playNotifcationSound(false);
      if (document.visibilityState !== 'visible') {
        document.title = 'TrueLark (New Message)';
      }
      this.props.clearNotificationMessage();
      this.setState({ lastNotifiedMessageId: incomingMessage });
    }
    // (conversation.action == 'FOLLOWUP_NEEDED' ||
    //       conversation.auto_chat_status === 'PAUSED') &&
    //staffCreated
    let activeCategory = this.state.addOnNotEnabled
      ? 'FOLLOWUP_NEEDED'
      : (follupConversation.length > 0 && assignedConversation_list.length < 1) ? 'FOLLOWUP_NEEDED' : 'MINE';

    let selectedConversation = {};
    if (activeCategory === 'MINE') {
      selectedConversation = (assignedConversation?.length > 0) ? assignedConversation_list[0] : null;
    } else if (activeCategory === 'FOLLOWUP_NEEDED') {
      selectedConversation = (follupConversation?.length > 0) ? follupConversation[0] : null;
    } else if (activeCategory === null) {
      selectedConversation = filterd_conversation[0];
    }
    const newcreatedConversation = filterd_conversation.filter(
      (conversation) => conversation.newlyCreated,
    );

    let transitioned = [];
    const { assignmentData } = nextProps.conversations;
    if (this.state.myList.length > assignedConversation_list.length) {
      transitioned = this.state.myList.filter(
        (x) => !assignedConversation_list.includes(x),
      );
    } else if (this.state.unassignedList.length > follupConversation.length) {
      transitioned = this.state.unassignedList.filter(
        (x) => !follupConversation.includes(x),
      );
    }
    if (
      this.state.createNewConversation &&
      newcreatedConversation?.length > 0 &&
      !this.state.newCreateSelected
    ) {
      activeCategory = 'MINE';
      selectedConversation = newcreatedConversation[0];
    }
    let current_active_conversation = this.state.selectedConversation;
    if (
      !this.state.defaultviewset ||
      newcreatedConversation?.length > 0 ||
      (transitioned?.length > 0 && this.state.activeCategory !== null)
    ) {
      current_active_conversation = selectedConversation;
      if (assignmentData && assignmentData.assigned_to === auth.userid) {
        activeCategory = 'MINE';
        // if(this.state.newCreateSelected){
        //   current_active_conversation = transitioned[0];
        // }
      }
    } else {
      current_active_conversation = this.state.selectedConversation
        ? filterd_conversation.filter(
          (conversation) =>
            this.getOtherConversationIDs(this.state.selectedConversation.id, conversation.id, conversation.otherconversation)
        )[0]
        : filterd_conversation[0];
    }
    let current_active_category = this.state.activeCategory;
    if (!this.state.defaultviewset || (newcreatedConversation && newcreatedConversation.length > 0) || (assignmentData && assignmentData.assigned_to === auth.userid)) {
      current_active_category = activeCategory;
    }
    const existing_jump_conversation = this.props.conversations.conversations.filter(
      (conversation) => conversation.jumptoThis,
    );
    if (existing_jump_conversation?.length > 0) {
      current_active_conversation = existing_jump_conversation[0];
      current_active_category = null;
    }
    let preserveSelectionId = null;
    if (!this.state.defaultviewset && this.state.searchLocal?.length > 0) {
      current_active_category = null;
      current_active_conversation = filterd_conversation[0];
    }
    if (
      transitioned &&
      transitioned.length > 0 &&
      !transitioned[0].staffCreated &&
      !this.state.dontShowTransition &&
      this.state.activeCategory !== null
    ) {
      if (
        this.state.selectedConversation &&
        transitioned.some(c => c.id === this.state.selectedConversation.id)
      ) {
        preserveSelectionId = this.state.selectedConversation.id;
        current_active_conversation = this.state.selectedConversation;
      } else {
        preserveSelectionId = transitioned[0].id; // fallback: first transitioned one
        current_active_conversation = transitioned[0];
      }
      current_active_category = 'MINE';
      this.setState({
        transitioned,
        showMobileDetailsView: false,
        newCreateSelected: true
      });
      setTimeout(() => {
        if (preserveSelectionId) {
          // keep the same conversation in MINE
          current_active_category = 'MINE';
          const preserved = assignedConversation_list.find(c => c.id === preserveSelectionId);
          selectedConversation = preserved || selectedConversation;
        } else if (current_active_category === 'MINE') {
          if (
            assignedConversation_list &&
            assignedConversation_list.length > 0
          ) {
            if (this.state.newCreateSelected && this.state.transitioned.length > 0) {
              selectedConversation = this.state.transitioned[0]
            } else {
              selectedConversation = assignedConversation_list[0];
            }
          } else {
            selectedConversation = null;
          }
        } else if (current_active_category === 'FOLLOWUP_NEEDED') {
          if (follupConversation && follupConversation.length > 0) {
            selectedConversation = follupConversation[0];
          } else {
            selectedConversation = null;
          }
        }
        if (!preserveSelectionId) {
          current_active_category = this.state.activeCategory;
          if (!this.state.defaultviewset) {
            current_active_category = activeCategory;
          }
        }
        this.setState({
          conversationslist: filterd_conversation,
          allConversationCount: filterd_conversation.length,
          follupConversationCount: follupConversation.length,
          myconversationCount: assignedConversation_list.length,
          myList: assignedConversation_list,
          unassignedList: follupConversation,
          selectedConversation,
          selectedDetailsConversation: selectedConversation,
          activeCategory: current_active_category,
          showSearch: true,
          transitioned: [],
          defaultviewset: true,
          dontShowTransition: false,
          ...(newcreatedConversation[0] === current_active_conversation,{newCreateSelected:true})
        });
      }, 3000);
    } else {
      this.setState({
        conversationslist: filterd_conversation,
        allConversationCount: filterd_conversation.length,
        follupConversationCount: follupConversation.length,
        myconversationCount: assignedConversation_list.length,
        myList: assignedConversation_list,
        unassignedList: follupConversation,
        selectedConversation: current_active_conversation,
        selectedDetailsConversation: current_active_conversation,
        activeCategory: current_active_category,
        showSearch: true,
        transitioned: [],
        dontShowTransition: false,
        ...(newcreatedConversation[0] === current_active_conversation, { newCreateSelected: true })
        //defaultviewset:true
      });
      if (!this.state.defaultviewset) {
        setTimeout(() => {
          this.setState({ defaultviewset: true });
        }, 3000);
      }
    }
  }

  checkToCallDetails = () => {
    const { selectedConversation, conversationslist } = this.state;
    const { conversations } = this.props;

    // Early returns for efficiency
    if (!selectedConversation) return;

    const tempSelected = conversationslist?.filter(conv => conv.id === selectedConversation.id);

    // Check if we need to call details
    const shouldCallDetails =
      tempSelected.length > 0 &&
      !conversations.getconversationDetails &&
      !tempSelected[0].newlyCreated &&
      (
        !tempSelected[0]?.details ||
        (
          tempSelected[0]?.details?.doApicall === true &&
          selectedConversation.details?.doApicall !== tempSelected[0]?.details?.doApicall
        )
      );

    if (shouldCallDetails) {
      this.onConversationSelect(tempSelected[0]);
    }
  }
  getOtherConversationIDs = (currentid, id, otherConversation) => {
    const ids = [id];
    otherConversation.forEach(conversation => {
      ids.push(conversation.id);
    })
    return ids.includes(currentid);
  }

  groupBydate(data) {
    const conversations = data.reduce((conversations, conversation) => {
      const date = moment(conversation.startTime)
        .startOf('day')
        .format('D');
      if (!conversations[date]) {
        conversations[date] = [];
      }
      conversations[date].push(conversation);
      return conversations;
    }, {});

    // Edit: to add it in the array format instead
    const groupArrays = Object.keys(conversations).map((date) => {
      return {
        date,
        conversations: conversations[date],
      };
    });
    return groupArrays;
  }
  groupBykey(data, key) {
    const conversations = data.reduce((conversations, conversation) => {
      const keyVal = conversation[key];
      if (!conversations[keyVal]) {
        conversations[keyVal] = [];
      }
      conversations[keyVal].push(conversation);
      return conversations;
    }, {});
    // Edit: to add it in the array format instead
    const groupArrays = Object.keys(conversations).map((keyVal) => {
      return {
        keyVal,
        conversations: conversations[keyVal],
      };
    });
    return groupArrays;
  }
  groupBykeyandreOrder(data) {
    let subgroup = [];
    data.sort(function (a, b) {
      return a.endTime > b.endTime ? -1 : 1;
    });

    if (data[0].notification_status === 'NONE') {
      for (let i = 1; i < data.length; i++) {
        if (data[i].notification_status !== 'NONE') {
          data[0].notification_status = data[i].notification_status;
          data[0].notification_read_status = data[i].notification_read_status;
          break;
        }
      }
    }
    if (data[0].inference === 'NONE') {
      for (let i = 1; i < data.length; i++) {
        if (data[i].inference !== 'NONE') {
          data[0].inference = data[i].inference;
          break;
        }
      }
    }
    if (data[0].new_client_created !== true) {
      for (let i = 1; i < data.length; i++) {
        if (data[i].new_client_created) {
          data[0].new_client_created = data[i].new_client_created;
          break;
        }
      }
    }
    data[0].allBookings = [];
    data[0].allTags = [];
    for (let i = 0; i < data.length; i++) {
      data[0].allBookings = data[0].allBookings.concat(data[i].bookings);
      data[0].allTags = data[0].allTags.concat(data[i].tags);
    }
    data[0].bookings = data[0].bookings.sort((a, b) =>
      a.timestamp > b.timestamp ? -1 : 1,
    );
    data[0].bookings = data[0].bookings.reduce((unique, o) => {
      if (!unique.some((obj) => obj.appointment_id === o.appointment_id)) {
        unique.push(o);
      }
      return unique;
    }, []);
    subgroup = data.splice(0, 1);
    subgroup[0].otherconversation = data;
    this.conversationslist.push(subgroup[0]);
    return subgroup[0];
  }
  loadMoreConversation = () => {
    if (!utils.isEmptyObject(this.state.selectedLocation)) {
      this.props.getConversations(
        this.state.selectedLocation.studioId,
        this.props.conversations.nextStartTime,
      );
    } else {
      this.props.getConversations(
        this.props.business.id,
        this.props.conversations.nextStartTime,
      );
    }
  };

  refreshConversation = () => {
    if (!utils.isEmptyObject(this.state.selectedLocation)) {
      this.props.getConversations(this.state.selectedLocation.studioId, false);
      //this.props.getConversationSummary(this.state.selectedLocation.studioId);
    } else {
      this.props.getConversations(this.props.business.id, false);
      //this.props.getConversationSummary(this.props.business.id);
    }
    this.setState({
      searchText: null,
      searchLocal: null,
      showSearch: false,
    });
  };
  backfromSearch = () => {
    this.props.clearSearch();
    this.setState({
      mainpage: true,
    });

    sessionStorage.removeItem('search');
    sessionStorage.removeItem('searchText');
    this.refreshConversation();
  };
  debounceSearch = debounce(
    (req) => this.props.searchConversation(req.bzid, req.searchText, req.isUserId),
    500,
  );
  searchConversationFunc = (searchText) => {
    if (searchText.target.value.length > 0) {
      let bzid = this.props.business.id || this.props.auth.studio_id;
      if (!utils.isEmptyObject(this.state.selectedLocation)) {
        bzid = this.state.selectedLocation.studioId;
      }
      this.debounceSearch({ bzid, searchText: searchText.target.value, isUserId: this.state.isUserIdSearch });
      this.setState({
        searchText: ltrim(searchText.target.value),
        searchLocal: ltrim(searchText.target.value),
        dontShowTransition: true,
        isUserIdSearch: false,
      });
    } else {
      this.setState({
        searchLocal: '',
        searchText: '',
        dontShowTransition: true,
        isUserIdSearch: false,
      }, () => this.onApplyfilter());
      this.props.clearSearch();
    }

  };
  // searchConversationFunc =(searchText)=>{
  //   this.setState({
  //     searchLocal:ltrim(searchText.target.value),
  //     dontShowTransition:true
  //   },()=>{this.onApplyfilter()})
  // }
  selectSearchContact = (contact) => {
    this.setState({
      searchContact: contact
    })
  }
  handlePaneClose = () => {
    let conversation = this.state.selectedConversation;
    if (
      conversation.notification_read_status_details &&
      conversation.notification_read_status_details === 'UNREAD'
    ) {
      conversation.notification_read_status_details = 'READ';
    }
    this.setState({
      paneVisibility: false,
    });
  };

  handleConversationClick = (conversation) => {
    this.setState({
      paneVisibility: true,
      selectedDetailsConversation: conversation,
    });
    ReactGA.event({
      category: 'Conversation',
      action: conversation.bzId,
      businessId: conversation.bzId,
    });
  };
  handleSearchResultCount = (conversations, displayData) => {
    const { brand_ids, businessName, studioId } = this.state.selectedLocation;
    let resultstring =
      displayData.length + ' results found for the last 30 days';
    if (
      brand_ids &&
      !brand_ids.includes(studioId) &&
      displayData.length === 0
    ) {
      resultstring = `No conversations found for ${businessName} location. Search all locations instead?`;
    }
    if (conversations.getconversations && this.state.searchText) {
      resultstring = 'Searching...';
    }
    return resultstring;
  };
  loadMoreloader = (loadmore) => {
    let view = (
      <button className="load-button" onClick={this.loadMoreConversation}>
        + Load older
      </button>
    );
    if (loadmore) {
      view = <Loading style={{ height: 50 }} />;
    }
    return view;
  };

  getSortedConversation = (allconversations, activeCategory) => {
    const { myList, unassignedList } = this.state;
    let conversations = allconversations;
    if (activeCategory === 'MINE') {
      conversations = myList;
    } else if (activeCategory === 'FOLLOWUP_NEEDED') {
      conversations = unassignedList;
    }
    conversations.sort((a, b) => {
      if (a.endTime !== b.endTime && a.endTime !== 0 && b.endTime !== 0) {
        a.displayTime = a.endTime;
        b.displayTime = b.endTime;
        return a.endTime > b.endTime ? -1 : 1;
      } else {
        a.displayTime = a.startTime;
        b.displayTime = b.startTime;
        return a.startTime > b.startTime ? -1 : 1;
      }
    });
    conversations.sort((a, b) => {
      return a.endTime > b.endTime ? -1 : 1;
    });
    return conversations;
  };

  changeFilter = (activeCategory, count) => {
    if (count > 0) {
      const { myList, unassignedList, conversationslist } = this.state;
      let selectedConversation =
        conversationslist.length > 0 ? conversationslist[0] : null;
      if (activeCategory === 'MINE') {
        selectedConversation = myList.length > 0 ? myList[0] : null;
      } else if (activeCategory === 'FOLLOWUP_NEEDED') {
        selectedConversation =
          unassignedList.length > 0 ? unassignedList[0] : null;
      }
      this.setState({
        activeCategory,
        selectedConversation,
        createNewConversation: false,
        defaultviewset: true,
      }, () => { this.props.clearNewlyCreatedFlags(); });
    } else {
      this.setState({
        activeCategory,
        selectedConversation: null,
        createNewConversation: false,
        defaultviewset: true,
      }, () => { this.props.clearNewlyCreatedFlags(); });
    }
  };
  selectConversation = (conversation) => {
    if (
      this.state.selectedConversation &&
      this.state.selectedConversation.notification_read_status === 'UNREAD' &&
      this.state.selectedConversation.unread_count > 0
    ) {
      this.props.readNotification(
        this.state.selectedConversation.bzId,
        this.state.selectedConversation.id,
      );
    }
    this.setState(
      {
        selectedConversation: conversation,
        defaultviewset: true,
        ...(window.innerWidth < 768 && { showMobileDetailsView: true })
      },
      () => {
        // if (conversation && !conversation.details) {
        this.onConversationSelect(conversation);
        // }
        this.props.clearNewlyCreatedFlags();
      },
    );
  };

  hideDetailsViewForMobile = () => {
    this.setState({
      showMobileDetailsView: false
    });
  }
  showFilterDropdown = (visibility) => {
    const { appliedFilter } = this.state;
    this.setState({
      showFilter: visibility,
      filter: appliedFilter,
    });
  };
  onFilterChange = (event) => {
    const { filter } = this.state;
    let temp = [...filter];
    if (temp.includes(event)) {
      temp = temp.filter((element) => element != event);
    } else {
      temp.push(event);
    }
    this.setState({
      filter: temp,
    });
  };
  applyFilter = () => {
    this.setState(
      {
        appliedFilter: this.state.filter,
        dontShowTransition: true,
      },
      () => {
        this.showFilterDropdown(false);
        this.onApplyfilter();
        this.props.clearNewlyCreatedFlags();
      },
    );
  };
  onApplyfilter = () => {
    const {
      searchLocal,
      appliedFilter,
      myList,
      unassignedList,
      activeCategory,
      addOnNotEnabled,
    } = this.state;
    const { auth } = this.props;
    const { allAssignmentMap, custom_tags } = this.props.conversations;
    const assignedConversation = allAssignmentMap
      .filter((user) => user.assigned_to === auth.userid)
      .map((item) => item['assigned_user']);
    const allAssignedConversation = allAssignmentMap.map(
      (item) => item['assigned_user'],
    );
    let conversations = [...this.conversationslist];
    conversations.sort((a, b) => {
      if (a.endTime !== b.endTime && a.endTime !== 0 && b.endTime !== 0) {
        a.displayTime = a.endTime;
        b.displayTime = b.endTime;
        return a.endTime > b.endTime ? -1 : 1;
      } else {
        a.displayTime = a.startTime;
        b.displayTime = b.startTime;
        return a.startTime > b.startTime ? -1 : 1;
      }
    });
    const now = Date.now();
    conversations.sort((a, b) => {
      return a.endTime > b.endTime ? -1 : 1;
    });
    const recentConversations = conversations
      .filter(convo => now - convo.endTime <= THIRTY_DAYS_IN_MS)
      .sort((a, b) => b.endTime - a.endTime); // More concise sort
    let filterd_conversation = recentConversations;
    
    if (searchLocal && searchLocal.length > 0) {
      const { auth } = this.props;
      const typeofUser =
        auth.domain_keywords && auth.domain_keywords.USER
          ? auth.domain_keywords.USER.toLowerCase()
          : 'client';
      filterd_conversation = conversations.filter((conversation) => {
        const name = helpers.getclientNameListMeta(conversation, typeofUser);
        const phone = helpers.getClientPhoneCleaned(conversation);
        if (
          name.toLowerCase().indexOf(searchLocal.toLowerCase()) !== -1 ||
          (helpers.getCleanedPhone(searchLocal).length > 0 &&
            phone.includes(helpers.getCleanedPhone(searchLocal)))
        ) {
          return conversation;
        }
      });
    }
    if (appliedFilter && appliedFilter.length > 0) {
      if (appliedFilter.includes('FOLLOWUP_NEEDED')) {
        filterd_conversation = filterd_conversation.filter(
          (conversation) => conversation.action === 'FOLLOWUP_NEEDED',
        );
      }
      if (appliedFilter.includes('PAUSED')) {
        filterd_conversation = filterd_conversation.filter(
          (conversation) => conversation.auto_chat_status === 'PAUSED',
        );
      }
      const searched_filter = [...filterd_conversation];
      if (
        appliedFilter.includes('ME') ||
        appliedFilter.includes('OTHERS') ||
        appliedFilter.includes('NONE')
      ) {
        let assignmentFilter = [];
        if (appliedFilter.includes('ME')) {
          assignmentFilter = assignmentFilter.concat(assignedConversation);
        }

        if (appliedFilter.includes('OTHERS')) {
          const otherAssignments = allAssignedConversation.filter(function (el) {
            return !assignedConversation.includes(el);
          });
          assignmentFilter = assignmentFilter.concat(otherAssignments);
        }

        filterd_conversation = filterd_conversation.filter((conversation) =>
          assignmentFilter.includes(conversation.userId),
        );
        if (appliedFilter.includes('NONE')) {
          filterd_conversation = filterd_conversation.concat(
            searched_filter.filter(
              (conversation) =>
                !allAssignedConversation.includes(conversation.userId),
            ),
          );
        }
      }
      const tags = [
        'BOOKING',
        'NEW_BOOKING',
        'RESCHEDULE',
        'CANCELLATION',
        'BOOKING_REQUEST',
        'RESCHEDULE_REQUEST',
        'CANCEL_REQUEST',
        'NEW',
        'HAPPY',
        'UNHAPPY',
        'LE_CAMPAIGN_IN_PROGRESS',
        'LE_BOOKED_ON_TRUELARK',
        'LE_BOOKED_OFF_PLATFORM',
        'LE_ENGAGED',
        'LE_UNRESPONSIVE',
        'UNRESPONSIVE',
        'IS_LANDLINE',
        'LE_OPTED_OUT',
        'LE_EXPIRED_CAMPAIGN',
        'APPOINTMENT_REMINDER_IN_PROGRESS',
        'APPOINTMENT_REMINDER_CONFIRMED',
        'APPOINTMENT_REMINDER_CANCELLED',
        'APPOINTMENT_REMINDER_RESCHEDULED',
        'APPOINTMENT_REMINDER_OPTED_OUT',
        'APPOINTMENT_REMINDER_UNCONFIRMED',
        'APPOINTMENT_REMINDER_UNABLE_TO_SEND',
        'APPOINTMENT_REMINDER_RESCHEDULE_REQUESTED',
        'APPOINTMENT_REMINDER_CANCEL_REQUESTED',
        'USING_INSURANCE',
        'OUT_OF_POCKET',
      ];
      const customtags = custom_tags.map(tag => tag.name);
      const status = ['FOLLOWUP_NEEDED', 'PAUSED'];
      const assignedto = ['ME', 'OTHERS', 'NONE'];
      console.log('customtags', customtags, tags.concat(status).concat(assignedto).concat(customtags));
      if (
        appliedFilter.some(
          (item) =>
            !tags
              .concat(status)
              .concat(assignedto)
              .concat(customtags)
              .includes(item),
        )
      ) {
        if (
          !appliedFilter.includes('MISSED_CALL') &&
          appliedFilter.includes('MISSED_CALL_VM')
        ) {
          filterd_conversation = filterd_conversation.filter(
            (conversation) =>
              conversation.initiatedFor === 'MISSED_CALL' &&
              conversation.allTags &&
              conversation.allTags.includes('HAS_VOICE_MAIL'),
          );
        } else {
          filterd_conversation = filterd_conversation.filter((conversation) => {
            if (appliedFilter.includes('MISSED_CALL')) {
              return appliedFilter.includes(conversation.initiatedFor) || conversation.initiatedFor === 'VOICE_CALL';
            }
            return appliedFilter.includes(conversation.initiatedFor);
          }
          );
        }
      }
      if (appliedFilter.some(item => tags.includes(item) || customtags.includes(item))) {
        const filtering = appliedFilter.includes('BOOKING')
          ? [...appliedFilter, 'NEW_BOOKING']
          : [...appliedFilter];
        filterd_conversation = filterd_conversation.filter((conversation) =>
          helpers
            .getTagsForFilter(conversation, true)
            .some((item) => filtering.includes(item)),
        );
      }
    }
    let unassignedTome = !addOnNotEnabled
      ? filterd_conversation.filter(
        (conversation) =>
          conversation.action === 'FOLLOWUP_NEEDED' &&
          !allAssignedConversation.includes(conversation.userId),
      )
      : filterd_conversation.filter(
        (conversation) => conversation.action === 'FOLLOWUP_NEEDED',
      );
    let assignedTome = filterd_conversation.filter(
      (conversation) =>
        (conversation.action == 'FOLLOWUP_NEEDED' ||
          conversation.auto_chat_status === 'PAUSED') &&
        assignedConversation.includes(conversation.userId),
    );
    let selectedConversation = null;
    if (activeCategory === 'MINE') {
      if (assignedTome && assignedTome.length > 0) {
        selectedConversation = assignedTome[0];
      } else {
        selectedConversation = null;
      }
    } else if (activeCategory === 'FOLLOWUP_NEEDED') {
      selectedConversation = assignedTome.length > 0 ? assignedTome[0] : null;
    } else {
      selectedConversation = filterd_conversation[0];
    }

    let transitioned = [];
    if (this.state.myList.length > assignedTome.length) {
      transitioned = this.state.myList.filter((x) => !assignedTome.includes(x));
    } else if (this.state.unassignedList.length > unassignedTome.length) {
      transitioned = this.state.unassignedList.filter(
        (x) => !unassignedTome.includes(x),
      );
    }
    const { assignmentData } = this.props.conversations;
    if (
      transitioned &&
      transitioned.length > 0 &&
      !this.state.dontShowTransition &&
      this.state.activeCategory !== null
    ) {
      this.setState({
        transitioned,
        showMobileDetailsView: false
      });
      setTimeout(() => {
        if (activeCategory === 'MINE') {
          if (assignedTome && assignedTome.length > 0) {
            selectedConversation = assignedTome[0];
          } else {
            selectedConversation = null;
          }
        } else if (activeCategory === 'FOLLOWUP_NEEDED') {
          if (unassignedTome && unassignedTome.length > 0) {
            selectedConversation = unassignedTome[0];
          } else {
            selectedConversation = null;
          }
        } else if (activeCategory === null) {
          selectedConversation = filterd_conversation[0];
        }
        this.setState({
          conversationslist: filterd_conversation,
          allConversationCount: filterd_conversation.length,
          follupConversationCount: unassignedTome.length,
          myconversationCount: assignedTome.length,
          myList: assignedTome,
          unassignedList: unassignedTome,
          selectedConversation,
          transitioned: [],
          dontShowTransition: false,
          defaultviewset: true,
        });
      }, 3000);
    } else {
      this.setState({
        conversationslist: filterd_conversation,
        allConversationCount: filterd_conversation.length,
        follupConversationCount: unassignedTome.length,
        myconversationCount: assignedTome.length,
        myList: assignedTome,
        unassignedList: unassignedTome,
        selectedConversation,
        transitioned: [],
        dontShowTransition: false,
      });
    }
  };
  clearFilter = () => {
    this.setState(
      {
        filter: [],
        appliedFilter: [],
        dontShowTransition: true,
      },
      () => {
        this.onApplyfilter();
      },
    );
  };

  addNewBrandConversation = () => {
    const { auth, business } = this.props;
    const { conversation_locations } = business;
    const { selectedLocation } = this.state;
    const newcreatedConversation = this.props.conversations.conversations.filter((conversation) => conversation.staffCreated,);
    if (
      newcreatedConversation &&
      newcreatedConversation.length > 0
    ) {
      this.setState(
        {
          createNewConversation: true,
          activeCategory: 'MINE',
          filter: [],
          appliedFilter: [],
          searchText: '',
          searchLocal: '',
          dontShowTransition: true,
          selectedConversation: newcreatedConversation[0],
          ...(window.innerWidth < 768 && { showMobileDetailsView: true }),
          newCreateSelected: false
        },
      );
    } else {
      this.setState(
        {
          createNewConversation: true,
          activeCategory: 'MINE',
          filter: [],
          appliedFilter: [],
          searchText: '',
          searchLocal: '',
          dontShowTransition: true,
          ...(window.innerWidth < 768 && { showMobileDetailsView: true })
        },
        () => {
          this.props.createNewConversation(auth, business, selectedLocation);
        },
      );
    }
  }
  addNewConversation = () => {
    const { auth, business } = this.props;
    const { conversation_locations } = business;
    const { selectedLocation } = this.state;
    this.props.clearJumpSelectionFlags();
    if (
      helpers.isBrandLocation(selectedLocation) &&
      conversation_locations.length > 1
    ) {
      this.setState({
        showLocationSelection: true,
      });
    } else {
      const newcreatedConversation = this.props.conversations.conversations.filter((conversation) => conversation.staffCreated,);
      if (
        newcreatedConversation &&
        newcreatedConversation.length > 0
      ) {
        this.setState(
          {
            createNewConversation: true,
            activeCategory: 'MINE',
            filter: [],
            appliedFilter: [],
            searchText: '',
            searchLocal: '',
            dontShowTransition: true,
            selectedConversation: newcreatedConversation[0],
            ...(window.innerWidth < 768 && { showMobileDetailsView: true }),
            newCreateSelected: false
          },
        );
      } else {
        this.setState(
          {
            createNewConversation: true,
            activeCategory: 'MINE',
            filter: [],
            appliedFilter: [],
            searchText: '',
            searchLocal: '',
            dontShowTransition: true,
            ...(window.innerWidth < 768 && { showMobileDetailsView: true })
          },
          () => {
            this.props.createNewConversation(auth, business, selectedLocation);
          },
        );
      }
    }
  };
  removeNewConversation = (id) => {
    this.setState(
      {
        createNewConversation: false,
        dontShowTransition: true,
      },
      () => {
        this.props.removeConversation(id);
      },
    );
  };
  createConversationWithContact = (bzid, id, conversation_object) => {
    this.setState({
      createNewConversation: false
    }, () => { this.props.createConversationInBackend(bzid, id, conversation_object); })
  }
  // onLocationChange=(location)=>{
  //   this.setState({
  //     selectedLocation:location
  //   });
  // }

  handleConversationSelect = (selectedConversation) => {
    let sessionIdArray = [];
    sessionIdArray = selectedConversation.otherconversation.map(
      (conversation) => {
        return conversation.id;
      },
    );
    sessionIdArray.push(selectedConversation.id);
    // this.props.getConversationDetailsbyUser({
    //   businessId: selectedConversation.bzId,
    //   sessionId: sessionIdArray,
    //   rootid: selectedConversation.id,
    //   convuserId: selectedConversation.userId,
    // });
  };
  onConversationSelect = (selectedConversation) => {
    this.debouncedConversationSelect(selectedConversation);
  };
  isNextElementActive = (sorted_list, index) => {
    const { selectedConversation } = this.state;
    if (
      !utils.isEmptyObject(selectedConversation) &&
      sorted_list.length > 2 &&
      index < sorted_list.length - 1
    ) {
      const active =
        selectedConversation.id === sorted_list[index + 1].id ? true : false;
      return active;
    }
    return false;
  };
  clearSearchLocal = () => {
    this.setState({
      searchLocal: '',
      searchText: ''
    }, () => this.onApplyfilter());
    this.props.clearSearch();
  }
  showLoadMoreButton = (conversations, conversationMeta) => {
    if (conversations && moment(conversations.nextStartTime).isSameOrAfter(moment().startOf('day').subtract(29, 'd'))) {
      return true;
    }
    return false;
  };

  setLocationSelectorVisibility = (flag) => {
    this.setState({
      showLocationSelection: flag,
    });
  };
  
  handleStatusChange = (event) => {
    if (event === 'Report') {
      this.setreportOverlayVisibility(true);
    } else if (event === 'Block') {
      this.setblockOverlayVisibility(true);
    } else if (event === 'Tags') {
      this.setTagOverlayVisibility(true);
    } else {
      this.setoptoutOverlayVisibility(true);
    }
  };
  
  setStatusDropdownVisibility = (visibility) => {
    this.setState({
      statusDropdownVisibility: visibility,
    });
  };
  
  setblockOverlayVisibility = (visibility) => {
    this.setState({
      blockOverlay: visibility,
    });
  };
  
  setTagOverlayVisibility = (visibility) => {
    this.setState({
      tagOverlay: visibility,
    });
  };
  
  setoptoutOverlayVisibility = (visibility) => {
    this.setState({
      optoutOverlay: visibility,
    });
  };
  
  render() {
    const {
      version,
      selectedLocation,
      paneVisibility,
      selectedDetailsConversation,
      activeCategory,
      allConversationCount,
      follupConversationCount,
      selectedConversation,
      conversationslist,
      mainpage,
      showSearch,
      showFilter,
      assignedUser,
      filter,
      createNewConversation,
      myconversationCount,
      addOnNotEnabled,
      appliedFilter,
      searchLocal,
      searchText,
      transitioned,
      filteredSearchList,
      searchLoading,
      showLocationSelection,
      showMobileDetailsView,
      statusDropdownVisibility,
      blockOverlay,
      optoutOverlay,
      tagOverlay,
    } = this.state;
    const {
      conversations,
      readNotification,
      auth,
      business,
      staffManagement,
      softwares,
    } = this.props;
    const {
      info,
      conversation_locations,
      isLocationfetchsuccess,
      locations,
    } = business;
    const typeofUser =
      auth.domain_keywords && auth.domain_keywords.USER
        ? auth.domain_keywords.USER.toLowerCase()
        : 'client';
    const showPaymntinfo =
      auth.features && auth.features.includes('CLIENT_CC_ENABLED')
        ? true
        : false;
    const {
      loadingMore,
      conversationMeta,
      assignmentData,
      minimizesidebar,
      assignedConversation,
      autoResponseChange,
      markResolved,
      allAssignmentMap,
      blockedNumbers,
      optoutnumbers,
      getConversationMetrics,
      fetchConversationMetricsSuccess,
      conversationMetrics,
      callerNameChangeSuccess,
      callerNameChangeFailure,
      counts,
    } = conversations;
    const sorted_list = this.getSortedConversation(
      conversationslist,
      activeCategory,
    );
    let feature_options = ['Block', 'Optout'];
    if (!csroles.includes(auth?.role)) {
      feature_options = ['Tags', 'Block', 'Optout'];
    }
    console.log('selectedConversation--->', selectedDetailsConversation, selectedConversation, blockOverlay, optoutOverlay);
    return (
      <div className="conversation">
        {conversations.getconversations &&
          !conversations.loadmore &&
          !conversations.search && (
            <div className="conversation_loader">
              <Loading />
            </div>
          )}
        <div className="conversation_title">
          <div
            className={classNames('conversation_title_layout', {
              'extend-layout': minimizesidebar,
            })}
          >
            {!conversations.getconversations && conversations && (
              <>
                <div className="conversation_title_layout_card">
                  {addOnNotEnabled && (
                    <div
                      className={classNames('addon-not-added', {
                        'addon-not-added-hide': showMobileDetailsView,
                      })}
                    >
                      <div className="addon-not-added_container">
                        <div className="addon-not-added_container_description">
                          Get the{' '}
                          <a
                            className="messenger-action"
                            href={window.Config.STAFF_TEXTING.GET_ADD_ON_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Business Messenger
                          </a>{' '}
                          add-on to reply to conversations, start new ones, and
                          more!
                        </div>
                        <a
                          className="addon-not-added_container_demo"
                          href={window.Config.STAFF_TEXTING.BOOK_DEMO_LINK}
                          target="_blank"
                        >
                          {' '}
                          <div className="booking-img">
                            <img src={BookDemo} /> <img src={BookDemoDowmn} />
                          </div>{' '}
                          Book a demo
                        </a>
                      </div>
                    </div>
                  )}
                  <div
                    className={classNames('conversation-lists', {
                      'extend-list': minimizesidebar,
                      'padd-top': addOnNotEnabled,
                      'conversation-lists-mobile-hide': showMobileDetailsView,
                    })}
                  >
                    <div className="conversation-createandsearch">
                      <div className="conversation-create">
                        <div className="conversation-create_title">
                          <div className="conversation-create_title_actiong-group">
                            <div className="conversation-create_title_actiong-group_description">
                              Conversations
                            </div>
                            <div className="action-and-filter_filter">
                              <a
                                href="#"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  event.preventDefault();
                                  this.setStatusDropdownVisibility(
                                    !statusDropdownVisibility,
                                  );
                                }}
                                className={classnames({
                                  'active-dropdowmn': statusDropdownVisibility,
                                })}
                              >
                                <i className="material-icons">more_vert</i>
                              </a>
                              <StatusSelectDropdown
                                visibility={statusDropdownVisibility}
                                position="br"
                                hideReport={true}
                                onVisibilityChange={(visibility) => {
                                  this.setStatusDropdownVisibility(visibility);
                                }}
                                allowedOptions={feature_options}
                                blockKnownNumber={false}
                                isBlocked={false}                                
                                // selectedOption={conversationStatus.value}
                                className="menu__dropdown report-block"
                                onChange={this.handleStatusChange}
                              />
                              <>{blockOverlay && (
                                <BlockOverlay
                                  setblockOverlayVisibility={this.setblockOverlayVisibility}
                                  modelopen={true}
                                  auth={auth}
                                  business={business}
                                  isBlocked={false}
                                  blockUser={this.props.postBlockUser}
                                  unblockPhone={this.props.unblockPhone}
                                  errorData={this.props.conversations}
                                  getBlockUser={this.props.getBlockUser}
                                  clearBlockData={this.props.clearBlockData}
                                  clearReportFlags={this.props.clearReportFlags}
                                  globalReport={false}
                                  typeofUser={typeofUser}
                                />
                              )}
                                {tagOverlay && (
                                  <CreateTagOverlay
                                    setTagOverlayVisibility={this.setTagOverlayVisibility}
                                    modelopen={true}
                                    auth={auth}
                                    business={business}
                                    conversations={conversations}
                                    addCustomTags={this.props.addCustomTags}
                                    deleteCustomTag={this.props.deleteCustomTag}
                                    getCustomTags={this.props.getCustomTags}
                                    errorData={this.props.conversations}
                                    clearReportFlags={this.props.clearReportFlags}
                                    globalReport={false}
                                    typeofUser={typeofUser}
                                  />
                                )}
                                {optoutOverlay && (
                                  <OptoutOverlay
                                    setoptoutOverlayVisibility={this.setoptoutOverlayVisibility}
                                    modelopen={true}
                                    auth={auth}
                                    business={business}
                                    blockUser={this.props.postBlockUser}
                                    errorData={this.props.conversations}
                                    getOptOutnumbers={this.props.getOptOutnumbers}
                                    getOptOutReport={this.props.getOptOutReport}
                                    clearBlockData={this.props.clearBlockData}
                                    clearReportFlags={this.props.clearReportFlags}
                                    selectedLocation={selectedLocation}
                                    typeofUser={typeofUser}
                                  />
                                )}</>
                            </div>
                          </div>
                          
                          <div className="conversation-create_title_date-range">
                            {isLocationfetchsuccess &&
                              conversation_locations.length > 1 && (
                                <div className="conversation_title_layout_refresh">
                                  <img
                                    src={location_pin}
                                    className="location-icon"
                                  />
                                  <BusinessName
                                    info={info}
                                    locations={conversation_locations}
                                    setSelectedLocation={this.onLocationChange}
                                    selectedLocation={selectedLocation}
                                  />
                                </div>
                              )}
                            <div>from the last 30 days</div>
                          </div>
                        </div>
                      </div>
                      <div className="conversation-search">
                        <div className="conversation-search_container">
                          <input
                            type="text"
                            name="search"
                            value={searchLocal}
                            autocomplete="do-not-autofill"
                            placeholder="Search by name or phone number"
                            className="conversation-search_container_searchbar"
                            onChange={this.searchConversationFunc}
                          />
                          {!searchLocal || searchLocal.trim().length < 1 ? (
                            <i className="material-icons">search</i>
                          ) : (
                            <i
                              className="material-icons"
                              onClick={this.clearSearchLocal}
                            >
                              close
                            </i>
                          )}
                        </div>
                        {!addOnNotEnabled && (
                          <div
                            className="conversation-create_new"
                            onClick={() => this.addNewConversation()}
                          >
                            <ReactTooltip />
                            <div
                              data-multiline={true}
                              data-tip-disable={false}
                              data-place={getToolTipPosition()}
                              data-tip={'Create a new conversation'}
                            >
                              <img src={conversationcreate} />{' '}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="conversation-category">
                      {!addOnNotEnabled && (
                        <div
                          className={classnames('conversation-category_name', {
                            'conversation-category_active':
                              activeCategory === 'MINE',
                          })}
                          onClick={() =>
                            this.changeFilter('MINE', myconversationCount)
                          }
                        >
                          Mine{' '}
                          <span className="conversation-category_name_counts counter">
                            ({myconversationCount})
                          </span>
                        </div>
                      )}
                      <div
                        className={classnames('conversation-category_name', {
                          'conversation-category_active':
                            activeCategory === 'FOLLOWUP_NEEDED',
                        })}
                        onClick={() =>
                          this.changeFilter(
                            'FOLLOWUP_NEEDED',
                            follupConversationCount,
                          )
                        }
                      >
                        {addOnNotEnabled ? 'Needs Attention' : 'Unassigned'}{' '}
                        <span className="conversation-category_name_counts counter">
                          ({follupConversationCount})
                        </span>
                      </div>
                      <div
                        className={classnames('conversation-category_name', {
                          'conversation-category_active':
                            activeCategory === null,
                        })}
                        onClick={() =>
                          this.changeFilter(null, allConversationCount)
                        }
                      >
                        All{' '}
                        <span className="conversation-category_name_counts counter">
                          ({allConversationCount})
                        </span>
                      </div>
                      <div className="conversation-category_name">
                        <a
                          href="#"
                          onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            this.showFilterDropdown(!showFilter);
                          }}
                        >
                          {appliedFilter.length > 0 ? (
                            <img src={filter_icon_blue} />
                          ) : (
                            <img src={filter_icon} />
                          )}
                          {appliedFilter.length > 0 && (
                            <div className="filter-count-container">
                              <div className="filter-count">
                                {appliedFilter.length}
                              </div>
                            </div>
                          )}
                        </a>
                        <FilterConversation
                          visibility={showFilter}
                          position="rc"
                          onVisibilityChange={(visibility) => {
                            this.showFilterDropdown(visibility);
                          }}
                          className="menu__dropdown conversation-filter"
                          onChange={(event) => {
                            this.onFilterChange(event);
                          }}
                          domain={auth.domain}
                          features={auth.features}
                          selectedOption={assignedUser}
                          addOnNotEnabled={addOnNotEnabled}
                          custom_tags={conversations.custom_tags}
                          filter={filter}
                          clearFilter={this.clearFilter}
                          applyFilter={this.applyFilter}
                        />
                      </div>
                    </div>
                    {!conversations.getconversations && (
                      <> {this.props.conversations.searchingConversation ? (
                        <div className="conversation-list-loader">
                          <div className="loader-text">
                            <div className="overlay-text">Searching...</div>
                            <Skeleton height={90} />
                          </div>
                        </div>
                      ) : (
                        <div className="conversation-list">
                          {sorted_list.length > 0 ? (
                            <>
                              {conversationslist &&
                                sorted_list.map((conversation, index) => {
                                  return (
                                    <ConversationList
                                      key={index}
                                      isNextElement={this.isNextElementActive(
                                        sorted_list,
                                        index,
                                      )}
                                      conversation={conversation}
                                      auth={auth}
                                      typeofUser={typeofUser}
                                      selectConversation={this.selectConversation}
                                      selectedConversation={selectedConversation}
                                      removeConversation={
                                        this.removeNewConversation
                                      }
                                      onConversationSelect={
                                        this.onConversationSelect
                                      }
                                      addOnNotEnabled={addOnNotEnabled}
                                      markResolved={markResolved}
                                      activeCategory={activeCategory}
                                      allAssignmentMap={allAssignmentMap}
                                      StaffManagement={this.props.staffManagement}
                                      transitioned={transitioned}
                                      assignmentData={assignmentData}
                                      blockedNumbers={blockedNumbers}
                                      optoutnumbers={optoutnumbers}
                                    />
                                  );
                                })}
                            </>
                          ) : (
                            <div className="conversation-list_noconv">
                              <div className="conversation-list_noconv_title">
                                No Conversations
                              </div>
                              <div className="conversation-list_noconv_description">
                                {activeCategory === 'MINE'
                                  ? 'Conversations assigned to you will show up here.'
                                  : activeCategory === 'FOLLOWUP_NEEDED'
                                    ? addOnNotEnabled
                                      ? 'Conversations that need attention will show up here.'
                                      : 'Unassigned conversations that need attention will show up here.'
                                    : 'All open conversations will show up here.'}
                              </div>
                            </div>
                          )}
                        </div>)}</>
                    )}
                    {this.showLoadMoreButton(
                      conversations,
                      conversationMeta,
                    ) && (
                        <div className="load-more">
                          <button
                            className={classnames('load-more_btn', {
                              disabled: loadingMore,
                            })}
                            onClick={this.loadMoreConversation}
                          >
                            {loadingMore ? 'Loading...' : 'Load More'}
                          </button>
                        </div>
                      )}
                  </div>
                  <div
                    className={classNames('conversation-details-container', {
                      'extend-details': minimizesidebar,
                      'padd-top': addOnNotEnabled,
                      'visible-details': showMobileDetailsView,
                    })}
                  >
                    {!conversations.getconversations &&
                      selectedConversation &&
                      !utils.isEmptyObject(selectedConversation) ? (
                      <ConversationDetails
                        addOnNotEnabled={addOnNotEnabled}
                        business={business}
                        conversation={selectedConversation}
                        sorted_list={sorted_list}
                        searchConversationText={searchLocal}
                        conversations={conversations}
                        auth={auth}
                        softwares={softwares}
                        typeofUser={typeofUser}
                        isLoadingTypescript={
                          conversations.getconversationDetails
                        }
                        handleConversationClick={this.handleConversationClick}
                        getConversationDetailsbyUser={
                          this.props.getConversationDetailsbyUser
                        }
                        erorReport={this.props.postErrorReport}
                        errorData={this.props.conversations}
                        unblockPhone={this.props.unblockPhone}
                        clearReportFlags={this.props.clearReportFlags}
                        getOptOutnumbers={this.props.getOptOutnumbers}
                        getOptOutReport={this.props.getOptOutReport}
                        getBlockUser={this.props.getBlockUser}
                        blockUser={this.props.postBlockUser}
                        selectedLocation={this.state.selectedLocation}
                        onStatusChange={this.props.postConversationStatus}
                        postClientNotes={this.props.postClientNotes}
                        sendMessage={this.props.sendMessage}
                        StaffManagement={this.props.staffManagement}
                        conversation_locations={conversation_locations}
                        assignConversation={this.props.assignConversation}
                        allAssignedConversation={
                          this.props.allAssignedConversation
                        }
                        changeAutoResponse={this.props.changeAutoResponse}
                        readNotification={readNotification}
                        autoResponseChange={autoResponseChange}
                        allAssignmentMap={allAssignmentMap}
                        activeCategory={activeCategory}
                        blockedNumbers={blockedNumbers}
                        optoutnumbers={optoutnumbers}
                        searchContact={this.props.searchContact}
                        searchLoading={this.state.searchLoading}
                        createConversationWithContact={
                          this.createConversationWithContact
                        }
                        createNewConversation={createNewConversation}
                        removeNewConversation={this.removeNewConversation}
                        showMobileDetailsView={showMobileDetailsView}
                        hideDetailsViewForMobile={this.hideDetailsViewForMobile}
                        selectContactforNewSession={
                          this.props.selectContactforNewSession
                        }
                        createContactInBackend={
                          this.props.createContactInBackend
                        }
                        clearJumpSelectionFlags={
                          this.props.clearJumpSelectionFlags
                        }
                        clearContactFlag={this.props.clearContactFlag}
                        callerNameChangeSuccess={callerNameChangeSuccess}
                        callerNameChangeFailure={callerNameChangeFailure}
                        addTagToUser={this.props.addTagToUser}
                        removeTagofUser={this.props.removeTagofUser}
                      />
                    ) : (
                      <div className="no-open-conv">
                        No open conversations here
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {!conversations.getconversations &&
          selectedDetailsConversation &&
          paneVisibility ? (
          <DetailsPane
            key={selectedConversation.id}
            selectedConversation={selectedDetailsConversation}
            visibility={paneVisibility}
            onClose={this.handlePaneClose}
            readNotification={readNotification}
            auth={auth}
            business={business}
            erorReport={this.props.postErrorReport}
            blockUser={this.props.postBlockUser}
            getBlockUser={this.props.getBlockUser}
            clearBlockData={this.props.clearBlockData}
            errorData={this.props.conversations}
            getConversationDetails={this.props.getConversationDetails}
            clearReportFlags={this.props.clearReportFlags}
            editCallerName={this.props.editCallerName}
            typeofUser={typeofUser}
            showPaymntinfo={showPaymntinfo}
            StaffManagement={staffManagement}
            addOnNotEnabled={addOnNotEnabled}
            callerNameChange={this.props?.conversations?.callerNameChange}
          />
        ) : null}
        {showLocationSelection && (
          <LocationSelector
            info={info}
            auth={auth}
            business={business}
            visibility={showLocationSelection}
            locations={conversation_locations}
            setLocationSelectorVisibility={this.setLocationSelectorVisibility}
            setSelectedLocation={this.locationChangeAndCreateConversation}
            selectedLocation={selectedLocation}
          />
        )}
      </div>
    );
  }
}
export default Conversations;
